import { Ref, ref, watch, onMounted, provide } from 'vue'
import { VALIDATE_CLS } from '@/components/utils/validate'
import { focusFirstControl } from '@/common/common-fn'

export const PROVIDE_KEY = 'VALIDATED'

const useAsValidateContainer = (autoFocus: Boolean) => {
  const validated = ref(false)
  const form: Ref = ref(null)
  const controls: Ref<any[]> = ref([])

  provide(PROVIDE_KEY, validated)

  // Lúc render ra thì get control để tý validate
  watch(form, (newVal) => {
    const controlVal = controls.value

    controlVal.splice(0, controlVal.length)
    if (newVal) {
      const validateControls = form.value.getElementsByClassName(VALIDATE_CLS)

      if (validateControls.length) {
        for (let i = 0; i < validateControls.length; i++) {
          const vueComp = validateControls[i]?.__vue__

          vueComp && controlVal.push(vueComp)
        }
      }
    }
  })

  onMounted(() => {
    const formElement = form.value

    if (autoFocus && formElement) {
      focusFirstControl(formElement)
    }
  })

  /**
   * @description Focus vào control lỗi đầu tiên
   * @author PHNam
   */
  const focusFirstError = (invalidControls: any[]) => {
    if (invalidControls.length > 0) {
      const firstErrorCtrl = invalidControls[0].$el.querySelector(
        'input, textarea, select'
      )

      firstErrorCtrl && firstErrorCtrl.focus()
    }
  }

  /**
   * @description Kiểm tra các control có hợp lệ hay không
   * @author PHNam
   */
  const isValid = () => {
    let isValid = true

    validated.value = true
    if (controls.value.length === 0) return isValid

    const invalidControls = controls.value.filter((control) => {
      return !control.isValid()
    })

    if (invalidControls.length > 0) {
      isValid = false
      autoFocus && focusFirstError(invalidControls)
    }

    return invalidControls.length === 0
  }

  /**
   * @description Reset lại các control
   * @author PHNam
   */
  const reset = () => {
    validated.value = false
    controls.value.forEach((control) => {
      control.reset()
    })
  }

  return {
    form,
    validated,
    focusFirstError,
    isValid,
    reset
  }
}

export default useAsValidateContainer
